import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { delay, Observable, of, shareReplay } from "rxjs";
import { VacanteResumen } from "../Interfaces/vacantes/vacante-resumen.interface";
import { VacantesResultados } from "../Interfaces/vacantes/vacantes-resultado.interface";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class HomeApiService {
    constructor(private httpClient: HttpClient) { }

    getVacantesPopulares(): Observable<VacantesResultados> {
        return this.httpClient
            .get<VacantesResultados>(`${environment.urlApiVacantes}/topTenVacantes`)
            .pipe(shareReplay(1));
    }
    getVacantesPorFecha(fechaDesde: string, fechaHasta: string): Observable<VacantesResultados> {
        return this.httpClient
            .get<VacantesResultados>(`${environment.urlApiVacantes}/buscarVacantesFecha?fecha_inicial=${fechaDesde}&fecha_final=${fechaHasta}`)
            .pipe(shareReplay(1));
    }
}